import { observer } from 'mobx-react-lite';
import React from 'react'
import { useStore } from '../../../../../lib/context';


const NavModuleSearchApplyButton = observer(() => {
    const {articleQueryStore: {canPerformQuery, performQuery, updateIsSearching}} = useStore();
    return (
        <div className={`flex--center ${canPerformQuery ? "active" : ""}`} onClick={() => {
            performQuery(true)
            updateIsSearching(false);
        }}>
            Apply

            <style jsx>{`
                div {
                    margin-top: 6px;
                    height: 40px;
                    border-radius: 40px;
                    width: 100%;
                    // background: white;
                    background: #5FE40A;
                    color: rgba(0,0,0,.4);
                    transition: color 0.2s ease, opacity 0.2s ease;
                    opacity: .85;
                    pointer-events: none;
                }

                .active {
                    color: black;
                    cursor: pointer;
                    pointer-events: all;
                }

                .active:hover {
                    opacity: 1;
                }
            `}</style>
        </div>
    )
})

export default NavModuleSearchApplyButton